import React, { useState } from "react";
import styles from "./RSVPPersonalized.module.css";
import {
  InputField,
  SubmitButton,
  TextareaField,
} from "../../../../../components";
import { RsvpIcon } from "../../../../../components/icons/Icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setRSVP } from "../../../../../Store/Actions/EventPlanningActions";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
const RSVPPersonalized = () => {
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);

  const [tagline, setTagline] = useState(RSVP?.tagline ? RSVP?.tagline : "");
  const [textArea, setTextArea] = useState(RSVP?.message ? RSVP?.message : "");

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const onNext = () => {
    if (!textArea || !tagline) {
      dispatch(
        showAlert({
          type: "error",
          message: "All fields are requird",
        })
      );
      return;
    }
    let data = {
      ...RSVP,
      tagline,
      message: textArea,
      invite_type: "message",
      // story: Story
    };
    dispatch(setRSVP(data));
    navigate("/events/RSVPTidbits", {
      state: {
        headrTitle: "Tidbits",
      },
    });
  };
  return (
    <div className={styles.mainCont}>
      <div className={styles.inputs}>
        <InputField
          label={"Add tagline here"}
          placeholder={"Add text"}
          value={tagline}
          onChange={(e) => setTagline(e.target.value)}
          inputClass={styles.input}
        />
        {/* <div className={styles.textAreaDiv}>
            <div className={styles.iconDiv}>
                <RsvpIcon/>
            </div>
          <TextareaField label={"Add Text for your guest"} 
           placeholder={"Add text here"}
           value={textArea}
           onChange={(e) => setTextArea(e.target.value)}
           rows={10}
          />
        </div> */}
        <div className={styles.secondInput}>
          <div className={styles.iconDiv}>
            <RsvpIcon size={"85%"} />
          </div>
          <div className={styles.textAreaDiv}>
            <TextareaField
              label={"Add Text for your guest"}
              placeholder={"Add text here"}
              value={textArea}
              onChange={(e) => setTextArea(e.target.value)}
              rows={10}
            />
          </div>
        </div>
      </div>
      <div className={styles.btnDiv}>
        <SubmitButton
          title="Next"
          btnClass={styles.btn}
          onClick={onNext}
          //   onClick={() => setrsvpModal(true)}
        />
      </div>
    </div>
  );
};

export default RSVPPersonalized;
